<template>
  <div class="no-data" :style="{ height: height + 'px'}">
    <i v-if="showBox" class="iconfont icon-kongxiangzi1" style="font-size: 100px"></i>
    <img v-else src="../assets/noData.png" :alt="$t('noData')" />
    <div style="height: 24px; line-height: 24px; margin-top: 10px">{{ $t('noData') }}</div>
  </div>
</template>
<script>
export default {
  name: 'noData',
  props: ['height', 'showBox']
}
</script>
<style lang="less" scoped>
.no-data {
  // border: 1px solid red;
  text-align: center;
  min-height: 200px;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  img {
    height: 150px;
  }
}
</style>